import { getCookie } from 'cookies-next';
import { COOKIE_NAMES } from '@/app/constants';

export const getMbbAttributionObject = () => {
  const mbbAttributionCookieEncoded = getCookie(COOKIE_NAMES.MBB_ATTRIBUTION);
  const mbbAttributionCookie = decodeURIComponent(mbbAttributionCookieEncoded as string);
  return mbbAttributionCookie.safeJsonParse();
};
